import React from "react";
import cx from "classnames";

type Props = {
  subscriptionId?: string | undefined;
  paymentId?: string | undefined;
  breadcrumb: Array<any>;
  title: string;
};

const Title: React.FC<Props> = ({
  title,
  breadcrumb,
  subscriptionId,
  paymentId,
}): JSX.Element => {
  return (
    <div
      className={`flex flex-col ${!subscriptionId || !paymentId ? "w-80" : "w-full"
        }`}
    >
      <h1
        className={cx(
          "font-sora text-2xl text-bt-green",
          breadcrumb.length > 0 ? "mt-10" : ""
        )}
        style={{
          fontStyle: "normal",
          fontWeight: 600,
        }}
      >
        {title}
      </h1>
    </div>
  );
};

export default Title;
